import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import noImage from "../../../../../assets/images/settings/no-image.png";
import PriceTag from "../../../../../assets/images/tagPrice.PNG";
import "./AdminGreetingsCompletedList.css";
import Nodata from "../../../../../assets/Icon/Nodata.png";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";
import ReactPaginate from "react-paginate";
import BaseReactPlayer from "react-player";
const AdminGreetingsCompletedList = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const [loading, setloading] = useState(true);
  const [greeting, setGreeting] = useState({});
  const [greetingList, setGreetingList] = useState([]);
  const [Checked, setChecked] = useState([]);

  const handelCheckBox = (greetings_id) => {
    const currentIndex = Checked.indexOf(greetings_id);
    const newChecked = [...Checked];
    if (currentIndex === -1) {
      newChecked.push(greetings_id);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const itemsPerPage = 5;
    const data = greetingList;
    useEffect(() => {
      const endOffset = itemOffset + itemsPerPage;
      setCurrentItems(data.slice(itemOffset, endOffset));
      setPageCount(Math.ceil(data.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, data]);
  
    const handlePageClick = (event) => {
      const newOffset = (event.selected * itemsPerPage) % data.length;
      setItemOffset(newOffset);
    };
  useEffect(() => {
    getAllGreetingRegWithPayment();
  }, []);

  const getAllGreetingRegWithPayment = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get("/api/admin/greetings_video_uploaded_list").then((res) => {
        if (res.data.status === 200) {
          setGreeting(res.data.greeting);
          setGreetingList(res.data.list);
        } else {
          swal("error", "Data base Error", "error");
        }
        setloading(false);
      });
    });
  };
  const handleClick = ()=>{
    const responseNotification = axios.post("/api/send/referral/notification", {
      user_id: 37655,
      title: "অভিনন্দন",
      body: "আপনার গ্রিটিং ভিডিও আপলোড হয়েছে।",
    });
  }
  console.log({Checked})
  const handleForwardToUserBtn = () => {
    if (Checked.length > 0) {
      const formData = new FormData();
      formData.append("greeting_registration_ids", Checked);

      axios
        .post(`/api/admin/greeting/forward_to_user`, formData)
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            getAllGreetingRegWithPayment();
            setChecked([]);
            // Checked.forEach(userId=>{
            //   axios.post("/api/send/referral/notification", {
            //     user_id: userId,
            //     title: "অভিনন্দন",
            //     body: "আপনার গ্রিটিং ভিডিও আপলোড হয়েছে।",
            //   });
            // })
          } else if (res.data.status === 422) {
            // setErrorList(res.data.validation_errors);
          } else {
            // swal("Error", res.data.message, "error");
          }
        });
    } else {
      swal("Opps...", "Please select some data", "warning");
    }
  };
  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          {Object.keys(greeting).length != 0 ? (
            <>
              <div>
                <div className="row mx-2">
                  <div className="col-md-7 mb-3">
                    <div className="card card-bg p-2">
                      <img
                        src={
                          greeting?.banner
                            ? imageCdnUrl+greeting?.banner
                            : noImage
                        }
                        alt=""
                        className=" img-fluid banner_re"
                      />
                    </div>
                  </div>
                  <div className="col-md-5 mb-3">
                    <div className="card card-bg p-2">
                      <ReactPlayer
                        url={
                          greeting?.video
                            ? videoCdnUrl + greeting?.video
                            : "https://www.youtube.com/watch?v=-X4ikwUwxoE"
                        }
                        width="100%" // height="100%" playing={false}
                        height="330px"
                        volume={1}
                        controls={true}
                        autoPlay
                      />
                    </div>
                  </div>
                </div>
                {/* <button
                  className="btn btn-warning bg-warning mt-3  NotiBtnts"
                  variant="primary"
                  onClick={() => handleClick()}
                >
                  <i className="fas fa-share"></i> Test notify
                </button> */}
                <div className="my-3 row mx-2">
                  <div className="col-md-7 mb-3">
                    <div className="card card-bg head-line mb-3">
                      <div className="text-light d-flex justify-content-center">
                        <h4 className="text-white p-2">
                          Greetings Completed List
                        </h4>
                      </div>
                    </div>

                    {currentItems.length !== 0 ? (
                      <>
                        <div className="row mb-2">
                          <div className="card card-bg">
                            <div className=" NotifyOver w-100">
                              {currentItems.map((data, index) => (
                                <table
                                  key={index}
                                  className="w-100 my-3 NotifyTabletd "
                                >
                                  <thead>
                                    <tr className="NotifyTable mx-3 text-center">
                                      <th></th>
                                      <th>User</th>
                                      <th>Request Date</th>
                                      <th>Purpose</th>
                                      <th>Video</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr className="NotifyTable mx-3">
                                      <td className="Notifytd">
                                        {Number(data.status) !== 2 ? (
                                          ""
                                        ) : (
                                          <input
                                            type="checkbox"
                                            value={data?.id}
                                            onChange={() =>
                                              handelCheckBox(parseInt(data?.id))
                                            }
                                            checked={Checked.includes(parseInt(data?.id))}
                                          />
                                        )}
                                      </td>

                                      <td className="Notifytdx lNTS">
                                        {" "}
                                        <img
                                          src={
                                            data.user?.image != null
                                              ? imageCdnUrl + data.user?.image
                                              : noImage
                                          }
                                          className="NotifyAimg"
                                          alt="profile"
                                        />
                                        {data.user?.first_name}{" "}
                                        {data.user?.last_name}
                                      </td>
                                      <td className="Notifytdx">
                                        {moment(data.request_time).format("LLL")}
                                      </td>
                                      
                                      <td className="Notifytdx rNTS">
                                        {data.purpose}
                                      </td>
                                      <td className="Notifytdx">
                                        {data?.video ? <BaseReactPlayer
                                          url={videoCdnUrl + data?.video}
                                          controls={true}
                                          volume={1}
                                          width="300px"
                                          height="auto"
                                          style={{ margin: "0 auto" }}
                                        /> : "No video uploaded"
                                        }
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              ))}
                              <div className="button mx-5 mb-5">
                                {Checked.length > 0 ? (
                                  <button
                                    className="btn btn-warning bg-warning mt-3  NotiBtnts"
                                    variant="primary"
                                    onClick={() => handleForwardToUserBtn()}
                                  >
                                    <i className="fas fa-share"></i> Forward to
                                    manager admin
                                  </button>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div id="react-paginate">
                          <ReactPaginate
                            breakLabel="..."
                            nextLabel="next >"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={3}
                            pageCount={pageCount}
                            previousLabel="< previous"
                            renderOnZeroPageCount={null}
                            breakLinkClassName={"page-link"}
                            containerClassName={"pagination"}
                            pageLinkClassName={"page-link"}
                            previousLinkClassName={"page-link"}
                            nextLinkClassName={"page-link"}
                            activeClassName={"active"}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        

                        <div className="row justify-content-center align-items-center">
                          <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
                            <img src={Nodata} alt="" className=" Nodata" />
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="col-md-5">
                    <div className="card card-bg px-3 py-4">
                      <div className="card card-bg head-line mb-2">
                        <div className="text-light d-flex justify-content-center p-2">
                          <div className="faTrophy">
                            <i className="fas fa-trophy"></i>
                          </div>
                          <h4 className="mx-3 text-white p-2">
                            {greeting?.title}
                          </h4>
                        </div>
                      </div>
                      {/* <h4 className="text-light">{greeting?.title}</h4> */}
                      <p className="text-light pt-1">
                        <Markup content={greeting?.instruction} />
                      </p>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="d-flex justify-content-center border border-warning bg-dark mt-3 p-2 buTon-a "
                          style={{ width: "100%" }}
                        >
                          <span>
                            <img src={PriceTag} alt="" className="PriceTage" />
                          </span>
                          <div className=" mx-2 ">
                            <span className="text-light buTon-ab ">Cost</span>
                            <br></br>
                            <span className="text-info fw-bold buTon-abc">
                              {greeting?.cost} $
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div
                          className="d-flex justify-content-center border border-warning bg-dark mt-3 p-2 buTon-a "
                          style={{ width: "100%" }}
                        >
                          <span>
                            <img src={PriceTag} alt="" className="PriceTage" />
                          </span>
                          <div className=" mx-2 ">
                            <span className="text-light buTon-ab ">
                              Minimum apply before
                            </span>
                            <br></br>
                            <span className="text-info fw-bold buTon-abc">
                              {greeting?.user_required_day} Day
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-md-5 mb-3">
                <ReactPlayer
                  className="ReactNAv"
                  url={
                    greeting?.video
                      ? base_url + greeting?.video
                      : "https://www.youtube.com/watch?v=-X4ikwUwxoE"
                  }
                  width="100%"
                  // height="100%"
                  playing={false}
                  volume={1}
                  controls={true}
                  autoPlay
                />
                <div className="card card-bg px-3 py-4 mt-3">
                  <h4 className="text-light">{greeting?.title}</h4>
                  <p className="text-light pt-1">
                    <Markup content={greeting?.instruction} />
                  </p>
                </div>
                <div
                  className="d-flex bg-dark mt-3 p-2 buTon-a "
                  style={{ width: "100%" }}
                >
                  <span>
                    <img src={PriceTag} alt="" className="PriceTage" />
                  </span>
                  <div className=" mx-2 ">
                    <span className="text-light buTon-ab ">Cost</span>
                    <br></br>
                    <span className="text-light buTon-abc">
                      {greeting?.cost} $
                    </span>
                  </div>
                </div>
                <div
                  className="d-flex bg-dark mt-3 p-2 buTon-a "
                  style={{ width: "100%" }}
                >
                  <span>
                    <img src={PriceTag} alt="" className="PriceTage" />
                  </span>
                  <div className=" mx-2 ">
                    <span className="text-light buTon-ab ">
                      Minimum apply before
                    </span>
                    <br></br>
                    <span className="text-light buTon-abc">
                      {greeting?.user_required_day} Day
                    </span>
                  </div>
                </div>
              </div> */}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="mx-2 row justify-content-center align-items-center">
                <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
                  <img src={Nodata} alt="" className=" Nodata" />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default AdminGreetingsCompletedList;
